import api from "./api";

export const getLanguages = async () => {
  return await api.get("/languages");
};
